import api from './api';

export const transferService = {
  // Tüm transferleri getir
  getAllTransfers: async (filters = {}) => {
    try {
      const response = await api.get('/transfers', { params: filters });
      return response.data;
    } catch (error) {
      console.error('Error fetching transfers:', error);
      throw error;
    }
  },

  // Transfer detayını getir
  getTransferById: async (id) => {
    try {
      const response = await api.get(`/transfers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching transfer details:', error);
      throw error;
    }
  },

  // Transfer oluştur
  createTransfer: async (transferData) => {
    try {
      const response = await api.post('/transfers', transferData);
      return response.data;
    } catch (error) {
      console.error('Error creating transfer:', error);
      throw error;
    }
  },

  // Transfer güncelle
  updateTransfer: async (id, transferData) => {
    try {
      const response = await api.put(`/transfers/${id}`, transferData);
      return response.data;
    } catch (error) {
      console.error('Error updating transfer:', error);
      throw error;
    }
  },

  // Transfer sil
  deleteTransfer: async (id) => {
    try {
      const response = await api.delete(`/transfers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting transfer:', error);
      throw error;
    }
  },

  // Taşıyıcı firmaya ata
  assignCarrier: async (transferId, carrierId) => {
    try {
      const response = await api.patch(
        `/transfers/${transferId}/assign-carrier`,
        { carrierId }
      );
      return response.data;
    } catch (error) {
      console.error('Error assigning carrier:', error);
      throw error;
    }
  },

  // Araca ata
  assignVehicle: async (transferId, vehicleId) => {
    try {
      const response = await api.patch(
        `/transfers/${transferId}/assign-vehicle`,
        { vehicleId }
      );
      return response.data;
    } catch (error) {
      console.error('Error assigning vehicle:', error);
      throw error;
    }
  },

  // Durum güncelle
  updateStatus: async (transferId, status) => {
    try {
      const response = await api.patch(
        `/transfers/${transferId}/status`,
        { status }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating status:', error);
      throw error;
    }
  },

  // Transfer komisyonu güncelle
  updateCommission: async (id, commissionData) => {
    try {
      const response = await api.put(`/transfers/${id}/commission`, commissionData);
      return response.data;
    } catch (error) {
      console.error('Error updating commission:', error);
      throw error;
    }
  },

  // Transfer komisyonu onayla
  approveCommission: async (id) => {
    try {
      const response = await api.put(`/transfers/${id}/commission/approve`);
      return response.data;
    } catch (error) {
      console.error('Error approving commission:', error);
      throw error;
    }
  },

  // Transfer komisyonu ödendi olarak işaretle
  markCommissionPaid: async (id) => {
    try {
      const response = await api.put(`/transfers/${id}/commission/paid`);
      return response.data;
    } catch (error) {
      console.error('Error marking commission as paid:', error);
      throw error;
    }
  },
  
  // Transfer ödeme durumunu güncelle
  updateTransferPaymentStatus: async (id, paymentData) => {
    try {
      const response = await api.patch(`/transfers/${id}/payment-status`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error updating transfer payment status:', error);
      throw error;
    }
  }
};

export default transferService;
